import { styled } from '../../styles/Theme';

const BillingStyle = styled.section`
  padding: 16px;

  .billing__content {
    background: #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
    padding: 32px;
    max-width: 1100px;
  }

  .billing-page__header {
    display: flex;
    justify-content: space-between;
  }

  .billing-page__header > a > button > i {
    margin-right: 10px;
  }

  .plans-content {
    display: flex;
    justify-content: space-between;
  }

  .list > .item {
    font-size: 0.92rem;
    margin-top: 0.5em;
  }
`;

export default BillingStyle;
